/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {useParams} from 'react-router-dom'
import {getServiceT003, putServiceT003} from '../../core/prestation/request'
import {useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {useAuth} from '../../../../auth'
import {ListeServiceStatus, putT003} from '../../core/prestation/model'
import {Button, Modal} from 'react-bootstrap'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import * as lodash from 'lodash'
import {RadioButton} from '../../../../../common/components/RadioButton/RadioButton'

const initialTBForm3Values = {
  OnConstructionSite: false,
  EstimatedNumberOfDays: '',
}

type ToogleButtonForm3Props = {
  isVisible2: boolean
  onDetectChange3?: (isThereChange: boolean) => void
  listeService?: any
  setListService?: any
  itemProps?: any
  setServiceData?: any
  onSavedForm?: (saved: boolean) => void
  loadListServiceStatus?: Function
  t003?: ListeServiceStatus
}

const ToogleButtonForm3: FC<ToogleButtonForm3Props> = ({
  isVisible2,
  onDetectChange3,
  listeService,
  setListService,
  itemProps,
  setServiceData,
  onSavedForm,
  t003,
  loadListServiceStatus,
}) => {
  const intl = useIntl()
  const {pGuid} = useParams()
  const projectData = useSelector((state: any) => state.projectData)
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  const [serviceT003, setServiceT003] = useState<any>(null)
  const {setAuthMessage, logout} = useAuth()
  const [t1init, setT1init] = useState<any>(initialTBForm3Values)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const {mode} = useThemeMode()
  const [loading, setLoading] = useState<boolean>(true)
  const [inputChange, setInputChange] = useState<any>(false)

  const onRefreshListeService3 = () => {
    const services: any[] = [...listeService]
    const data = services.find((item) => item === itemProps)
    if (data) {
      const index = services.findIndex((item) => item === itemProps)
      if (index === -1) {
        //return
      }
      services.splice(index, 1, {...itemProps, Completed: true})
      setServiceData(itemProps)
      setListService(services)
    }
  }

  const loadServiceT003 = async () => {
    const response = await getServiceT003(
      pGuid || projectData?.tab1?.data?.Guid || '',
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response?.data && response?.data?.data) {
      setServiceT003(response?.data?.data)
      setT1init(response?.data?.data)
    }
    setLoading(false)
  }
  useEffect(() => {
    loadServiceT003()
  }, [])

  const handleClickT003 = async () => {
    try {
      if (serviceT003) {
        const dataToUpdate: putT003 = {
          ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
          WithoutArm: false,
          OnConstructionSite: serviceT003.OnConstructionSite,
          EstimatedNumberOfDays: serviceT003.EstimatedNumberOfDays || '',
        }
        console.log('Data to update:', dataToUpdate)

        const response = await putServiceT003(dataToUpdate)
        if (response?.data?.Status?.Success) {
          if (onSavedForm) {
            onSavedForm(true)
          }
          console.log('Changements enregistrés !')
        }
        await loadServiceT003()
        await onRefreshListeService3()
        if (loadListServiceStatus) await loadListServiceStatus()
      } else {
        console.log("serviceT003 n'est pas encore prêt.")
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des données :", error)
      toast.error("Une erreur s'est produite lors de l'enregistrement des données")
    }
  }
  const isDisabled = useMemo(() => {
    return lodash.isEqual(serviceT003, t1init)
  }, [serviceT003, t1init])

  const onCancelReset = () => {
    setShowCancel(false)
  }
  const onConfirmCancel = async () => {
    if (pGuid) {
      await loadServiceT003()
      setShowCancel(false)
    } else {
      setServiceT003({...t1init})
      await loadServiceT003()
      setShowCancel(false)
    }
  }

  useEffect(() => {
    if (onDetectChange3) {
      onDetectChange3(isDisabled)
    }
  }, [isDisabled, onDetectChange3])

  return (
    <div>
      {isVisible2 && (
        <div className='d-flex flex-column'>
          <form>
            <div className='p-5 mt-8'>
              <div className='gap-5 d-flex justify-content-xl-between justify-content-lg-between  flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column my-5'>
                <label className='fs-5 text-gray-700' style={{flex: 0.45}}>
                  {intl.formatMessage({id: 'ON.CONSTRUCTION.SITE'})}{' '}
                </label>
                <div className='d-flex gap-10' style={{flex: 0.55}}>
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'YES'})}
                    checked={serviceT003?.OnConstructionSite === true}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT003({...serviceT003, OnConstructionSite: true})
                    }}
                  />
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'NO'})}
                    checked={serviceT003?.OnConstructionSite === false}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT003({...serviceT003, OnConstructionSite: false})
                    }}
                  />
                </div>
              </div>
              {/*
              <div className='gap-5 d-flex justify-content-xl-between justify-content-lg-between  flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column my-5'>
                <label className='fs-5 text-gray-700 mt-3' style={{flex: 0.45}}>
                  {intl.formatMessage({id: 'ESTIMATED.NUMBER.OF.DAY'})}
                </label>
                <div style={{flex: 0.55}}>
                  <input
                    type='number'
                    className='form-control form-control-solid w-50'
                    placeholder={intl.formatMessage({id: 'NUMBER'})}
                    value={serviceT003?.EstimatedNumberOfDays || ''}
                    disabled={Submitted}
                    onChange={(e) => {
                      setServiceT003({...serviceT003, EstimatedNumberOfDays: e.target.value})
                      setInputChange(true)
                    }}
                  />
                </div>
              </div>
*/}
              {!Submitted && (
                <div className='d-flex gap-5 justify-content-end my-5'>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      className='btn btn-dark'
                      disabled={isDisabled}
                      onClick={() => {
                        if (!lodash.isEqual(serviceT003, t1init)) {
                          setShowCancel(true)
                        } else {
                          if (inputChange) {
                            setServiceT003({...t1init})
                            setInputChange(false)
                          }
                        }
                      }}
                    >
                      {intl.formatMessage({id: 'RESET'})}
                      <i className='fa-solid fa-eraser fs-4 ms-2'></i>
                    </Button>
                  </span>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      type='button'
                      className='btn btn-danger'
                      onClick={handleClickT003}
                      disabled={isDisabled}
                    >
                      {intl.formatMessage({id: 'SAVE'})}
                      <i className='fa-regular fa-floppy-disk fs-4 ms-2'></i>
                    </Button>
                  </span>
                </div>
              )}
            </div>
          </form>
          <Modal show={showCancel} centered>
            <div className='text-center p-5 w-100' data-bs-theme={mode}>
              <div
                className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
                data-bs-theme={mode}
              >
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='fw-bolder text-gray-700 py-3'>
                    {intl.formatMessage({id: 'INFORMATION'})}
                  </div>
                  <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                    <i className='fa fa-close text-danger'></i>
                  </div>
                </div>
                <div className={'text-start py-3'}>
                  <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
                </div>
                <div className='d-flex align-items-center justify-content-evenly'>
                  <button className={'btn btn-secondary'} onClick={onCancelReset}>
                    {intl.formatMessage({id: 'NO'})}
                  </button>
                  {!loading && (
                    <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                      {intl.formatMessage({id: 'YES'})}
                    </button>
                  )}
                  {loading && (
                    <button className={'btn btn-primary'} onClick={() => {}}>
                      {'...'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default ToogleButtonForm3
